import { render, staticRenderFns } from "./financial sector.vue?vue&type=template&id=6517616e&scoped=true&"
import script from "./financial sector.vue?vue&type=script&lang=js&"
export * from "./financial sector.vue?vue&type=script&lang=js&"
import style0 from "./financial sector.vue?vue&type=style&index=0&id=6517616e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6517616e",
  null
  
)

export default component.exports